import React from 'react';
import './GalleryGrid.css';

const GalleryGrid = ({ images, onImageClick }) => {
  return (
    <div className="gallery-grid-container">
      {images.map((image, index) => (
        <div 
          key={image.id} 
          className="gallery-item"
          onClick={() => onImageClick(index)}
        >
          <img 
            src={image.url} 
            alt={image.title}
            className="gallery-image"
          />
          <div className="gallery-overlay">
            <span className="gallery-item-title">{image.title}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GalleryGrid;